const e = "Zwiększ liczbę", n = "Zmniejsz liczbę", c = {
  increment: e,
  decrement: n
};
export {
  n as decrement,
  c as default,
  e as increment
};
